<template>
    <div>
        <page-header :title="$t('pages.notifications.title')" icon-class="mdi mdi-bell-outline">

            <button class="btn btn-outline-dark btn-sm float-right mb-4" @click="markAllAsRead">
                <i class="mdi mdi-checkbox-marked-outline"></i>
                {{ $t('pages.notifications.mark_all_read') }}
            </button>
        </page-header>

        <div class="alert alert-light" v-if="!notifications.length">
            {{ $t('pages.notifications.no_notifications') }}
        </div>

        <div v-if="notifications.length">
            <div class="row"  v-for="notification in notifications">
                <div class="col-12 grid-margin">
                    <div class="card" :class="{'notification-read': isNotificationRead(notification)}">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-1">
                                    <div class="notification-thumbnail mb-2">
                                        <div class="preview-icon" :class="notification.data.meta.type">
                                            <i :class="notification.data.meta.icon"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-9">
                                    <h5 class="card-title">{{ notification.data.title }}</h5>
                                    <p v-html="notification.data.text"></p>
                                </div>
                                <div class="col-md-2 text-right">
                                    {{ $date(notification.created_at).format('LLL') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../Includes/PageHeader";
import NotificationRepository from "../../repositories/Notifications/NotificationRepository";
import AuthRepository from "../../repositories/Auth/AuthRepository";
export default {
    name: "NotificationView",
    components: {PageHeader},
    data: () => ({
        notifications: []
    }),
    mounted() {
        this.getNotifications();
    },
    methods: {
        getNotifications() {
            NotificationRepository
                .get()
                .then((res) => this.notifications = res.data);
        },

        isNotificationRead(notification) {
            return notification.read_at !== null;
        },

        markAllAsRead() {
            NotificationRepository
                .markAllAsRead()
                .then((res) => this.notifications = res.data)
                .then(() => AuthRepository.fetchAuthDetails(true))
                .then(() => this.$snotify.success(this.$t('pages.notifications.marked_all_as_read')));
        }
    }
}
</script>

<style scoped>
    .notification-read {
        opacity: 0.3;
    }
</style>
